import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Star, Loader2, CheckCircle2, ShieldCheck } from "lucide-react";
import api from "../lib/api";
import { toast } from "sonner";

export default function PublicReferentReview() {
  const { token } = useParams();
  const [info, setInfo] = useState(null);
  const [scores, setScores] = useState({});
  const [comment, setComment] = useState("");
  const [state, setState] = useState("loading");
  useEffect(() => {
    api.get(`/public/referent-review/${token}`).then((r) => {
      setInfo(r.data);
      const s = {}; (r.data.criteria || []).forEach((c) => { s[c.key] = 5; }); setScores(s);
      setState(r.data.submitted ? "done" : "ready");
    }).catch(() => setState("invalid"));
  }, [token]);
  const submit = async () => {
    try { await api.post(`/public/referent-review/${token}`, { criteria: scores, comment }); setState("done"); toast.success("Merci pour votre évaluation"); }
    catch (e) { toast.error(e?.response?.data?.detail || "Erreur"); }
  };
  return (
    <div className="min-h-screen bg-brand-softer flex items-center justify-center p-4">
      <div className="bg-white rounded-3xl border border-brand-soft p-8 w-full max-w-md" data-testid="public-review-page">
        <div className="w-12 h-12 rounded-2xl bg-brand-lime/30 text-brand-greenDeep flex items-center justify-center"><ShieldCheck className="w-6 h-6" /></div>
        {state === "loading" && <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-brand-green/40" /></div>}
        {state === "invalid" && <p className="text-sm text-brand-green/60 mt-4">Ce lien d'évaluation est invalide ou a expiré.</p>}
        {state === "done" && (
          <div className="mt-4 text-center"><CheckCircle2 className="w-10 h-10 text-emerald-500 mx-auto" /><p className="font-semibold text-brand-greenDeep mt-3">Merci !</p><p className="text-sm text-brand-green/60 mt-1">Votre évaluation a bien été enregistrée.</p></div>
        )}
        {state === "ready" && info && (
          <>
            <h1 className="font-display text-xl font-semibold text-brand-greenDeep mt-4">Évaluez {info.referent_name}</h1>
            <p className="text-sm text-brand-green/55">{info.mission_label}{info.property_name ? ` · ${info.property_name}` : ""}</p>
            <div className="mt-5 space-y-2">
              {(info.criteria || []).map((c) => (
                <div key={c.key} className="flex items-center justify-between" data-testid={`pr-crit-${c.key}`}>
                  <span className="text-sm text-brand-green/70">{c.label}</span>
                  <div className="flex gap-0.5">{[1, 2, 3, 4, 5].map((i) => <button key={i} onClick={() => setScores((s) => ({ ...s, [c.key]: i }))} data-testid={`pr-${c.key}-${i}`}><Star className={`w-5 h-5 ${i <= (scores[c.key] || 0) ? "text-amber-400 fill-amber-400" : "text-brand-soft"}`} /></button>)}</div>
                </div>
              ))}
            </div>
            <textarea value={comment} onChange={(e) => setComment(e.target.value)} placeholder="Un commentaire ? (optionnel)" className="w-full mt-4 px-3 py-2 rounded-xl border border-brand-soft text-sm" rows={3} data-testid="pr-comment" />
            <button onClick={submit} className="mt-4 w-full py-3 rounded-full bg-brand-greenDeep hover:bg-brand-green text-white font-semibold" data-testid="pr-submit">Envoyer mon évaluation</button>
          </>
        )}
      </div>
    </div>
  );
}
